export enum PayOtherAmountV1Status {
  AllDocumentsPaid = 'all-documents-paid',
  DocumentShortPaid = 'documents-paid-with-short-pay',
  UnableToPayOtherAmount = 'unable-to-pay-other-amount',
  PartialManagedAutoPay = 'partial-managed-auto-pay',
}
